import {Dispatch, SetStateAction, useEffect} from "react"
import Button from "@/components/ui-kit/button"
import {AnimatePresence, motion} from "framer-motion"
import {classNames} from "@/library/utilities/html"
import {pair} from "@/library/types/pair"
import {Product, ProductVersion} from "@/library/api/models/changelog"
import {Link} from "@tanstack/react-router"
import useChangelog from "@/components/changelog/context/_hook.changelog"

type ChangelogFiltersProps = {
    creatingNewState: [boolean, Dispatch<SetStateAction<boolean>>]
    canCreate: boolean
    products: Product[]
    versions: ProductVersion[]
}

export default function ChangelogFilters(
    {
        creatingNewState,
        canCreate = false,
        products,
        versions
    }: ChangelogFiltersProps
) {
    const [creatingNew, setCreatingNew] = creatingNewState
    const {currentProduct} = useChangelog()

    return <>
        {canCreate && products.length > 0 && <Button
            type="button"
            tabIndex={1}
            color="primary"
            onClick={() => setCreatingNew(() => true)}
            disabled={creatingNew}
        ><i className="far fa-plus-square"></i> Ny versjon</Button>}

        <motion.div className="filter filter--product">
            <div className="filter-heading">
                <div className="heading">Produkter</div>
                <div className="sub-heading">Se endringer for valgt produkt</div>
            </div>
            {products.length <= 0 && <div className="alert alert--warning alert--small">Ingen produkter opprettet enda...</div>}
            {products.length > 0 && <ul>
                {products.map(p => <li key={`select-product-${p.id}`}>
                    <Link className={classNames(pair("active", p.refKey == currentProduct?.refKey))}
                          to="../$refKey"
                          params={{
                              refKey: p.refKey
                          }}
                          search={{}}
                          onClick={() => {
                              //selectProduct(p.refKey)
                              //window.history.replaceState(null, "", `${window.location.origin}${window.location.pathname}/../${p.refKey}`)
                          }}>{p.name}</Link>
                </li>)}
            </ul>}
        </motion.div>

        <motion.div className="filter filter--versions">
            <motion.div className="filter-heading">
                <div className="heading">Versjoner</div>
                <div className="sub-heading">Vis valgt versjon på siden</div>
            </motion.div>
            <AnimatePresence mode="wait">
                {(versions.length ?? 0) == 0 &&
                    <motion.div className="alert alert--warning alert--small"
                                style={{
                                    marginTop: ".5rem"
                                }}
                                initial={{
                                    opacity: 0,
                                    y: -10
                                }}
                                animate={{
                                    opacity: 1,
                                    y: 0
                                }}
                                exit={{
                                    opacity: 0,
                                    x: 80
                                }}
                    >Ingen versjoner enda...</motion.div>
                }

                {(versions.length ?? 0) > 0 &&
                    <motion.ul exit={{
                        opacity: 0,
                        x: 80
                    }}>
                        <AnimatePresence mode="popLayout">
                            {versions.map((version, i) =>
                                <motion.li key={`scroll-to-version-${version.id}`}
                                           initial={{
                                               opacity: 0,
                                               x: -30
                                           }}
                                           animate={{
                                               opacity: 1,
                                               x: 0,
                                               transition: {
                                                   delay: (i * 0.04) + 0.10
                                               }
                                           }}
                                           exit={{
                                               opacity: 0,
                                               height: 0,
                                               x: 50
                                           }}>
                                    <Link to={`#${version.number}`} params="" search="">{version.number}</Link>
                                </motion.li>
                            )}
                        </AnimatePresence>
                    </motion.ul>
                }
            </AnimatePresence>
        </motion.div>
    </>
}
